import React from 'react'
import { Link } from 'gatsby'

import SocialIcons from '~/components/SocialIcons'

import { TwoColumnGrid } from '~/utils/styles'
import { Container, Wrapper, Left, Right } from './styles'

const Footer = () => {
  return (
    <Wrapper>
      <Container>
        <TwoColumnGrid>
          <Left>
            <div>
              <SocialIcons />
              Email Nooro:{' '}
              <a
                className="contact-link"
                href="mailto:hello@getnooro.com"
                aria-describedby="a11y-external-message"
              >
                hello@getnooro.com
              </a>{' '}
              <br />
              Phone Nooro:{' '}
              <a
                className="contact-link"
                target="_blank"
                href="tel:+44020 3858  9796"
                aria-describedby="a11y-new-window-external-message"
                rel="noopener noreferrer"
              >
                020 3858 9796
              </a>
            </div>
          </Left>
          <Right>
            <div>
              <Link to="/terms-conditions">Terms & Conditions</Link>
              <br />
              <br />
              &copy; 2021 Nooro LTD
              <br />
              Co Reg 10261807
            </div>
          </Right>
        </TwoColumnGrid>
      </Container>
    </Wrapper>
  )
}

export default Footer
